import { render, staticRenderFns } from "./Fullpage.vue?vue&type=template&id=45ae9838&scoped=true"
import script from "./Fullpage.vue?vue&type=script&lang=js"
export * from "./Fullpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae9838",
  null
  
)

export default component.exports